import app from '../app';
import Component from '../../common/Component';
import humanTime from '../../common/utils/humanTime';
import Tooltip from '../../common/components/Tooltip';
/**
 * The `PostEdited` component displays information about when and by whom a post
 * was edited.
 */
export default class PostEdited extends Component {
  view() {
    const post = this.attrs.post;
    const editedUser = post.editedUser();
    const editedInfo = app.translator.trans('core.forum.post.edited_tooltip', {
      user: editedUser,
      ago: humanTime(post.editedAt())
    });
    return m(Tooltip, {
      text: editedInfo
    }, m("span", {
      className: "PostEdited"
    }, app.translator.trans('core.forum.post.edited_text')));
  }
}
flarum.reg.add('core', 'forum/components/PostEdited', PostEdited);